import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { ApiKeyActions } from "./index";
import {
    FETCH_APIKEY_LIST_PROGRESS,
    FETCH_APIKEY_LIST_SUCCESS,
    FETCH_APIKEY_LIST_FAILED,
    FETCH_APIKEY_PROGRESS,
    FETCH_APIKEY_SUCCESS,
    FETCH_APIKEY_FAILED,
    CLEAR_APIKEY_STATE,
    CLEAR_APIKEY,
} from "./apikey.actions";
import { initialApiKeyState } from "./apikey.states";

export const apiKeyReducer = (
    state: IStoreState["apikey"] = initialApiKeyState,
    action: ApiKeyActions
) => {
    switch (action.type) {
        // ==================== API KEY LIST REDUCERS ====================

        case FETCH_APIKEY_LIST_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.ApiKey.list.loading = LoadState.InProgress;
                draftState.ApiKey.list.list = [];
                draftState.ApiKey.list.totalRecords = 0;
                draftState.ApiKey.list.error = null;
            });
        }

        case FETCH_APIKEY_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            return produce(state, (draftState) => {
                draftState.ApiKey.list.loading = LoadState.Loaded;
                draftState.ApiKey.list.list = list;
                draftState.ApiKey.list.totalRecords = totalRecords;
            });
        }

        case FETCH_APIKEY_LIST_FAILED: {
            return produce(state, (draftState) => {
                draftState.ApiKey.list.loading = LoadState.Failed;
                draftState.ApiKey.list.list = [];
                draftState.ApiKey.list.totalRecords = 0;
            });
        }

        // ==================== SINGLE API KEY REDUCERS ====================

        case FETCH_APIKEY_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.ApiKey.data.loading = LoadState.InProgress;
                draftState.ApiKey.data.data = null;
                draftState.ApiKey.data.error = null;
            });
        }

        case FETCH_APIKEY_SUCCESS: {
            const { apiKey } = action.payload;
            return produce(state, (draftState) => {
                draftState.ApiKey.data.loading = LoadState.Loaded;
                draftState.ApiKey.data.data = apiKey;
            });
        }

        case FETCH_APIKEY_FAILED: {
            const { errorMessage } = action.payload;
            return produce(state, (draftState) => {
                draftState.ApiKey.data.loading = LoadState.Failed;
                draftState.ApiKey.data.error = errorMessage;
            });
        }

        // ==================== CLEAR REDUCERS ====================

        case CLEAR_APIKEY: {
            return produce(state, (draftState) => {
                draftState.ApiKey.data.loading = LoadState.NotLoaded;
                draftState.ApiKey.data.data = null;
                draftState.ApiKey.data.error = null;
            });
        }

        case CLEAR_APIKEY_STATE: {
            return produce(state, (draftState) => {
                draftState.ApiKey = initialApiKeyState.ApiKey;
            });
        }

        default: {
            return state;
        }
    }
};
